export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-geo/src/identity.js
// module id = ../../../../d3-geo/src/identity.js
// module chunks = vendor